import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from './utils/axios'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
Vue.component('Header', Header)
Vue.component('Footer', Footer)


// 全局注册
Vue.use(ElementUI)
Vue.use(VueQuillEditor)

// 挂载axios到Vue原型
Vue.prototype.$axios = axios
Vue.prototype.$store = store

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App),
});
